import { ActiveGameStore as BaseStore } from '@bn-games/history-core';
import type { ActiveSession } from './types.js';
import { HISTORY_SCHEMA_VERSION } from './types.js';

// Per-app singleton wrapping @bn-games/history-core's generic store with
// checkers' storage key + schema version + shape predicate. Both the recorder
// and main.ts read/write via this instance.
export const ActiveGameStore = new BaseStore<ActiveSession>({
  storageKey: 'checkers-active-game',
  schemaVersion: HISTORY_SCHEMA_VERSION,
  isValid: (parsed) => parsed.seed !== undefined && Array.isArray(parsed.moves),
});
